module.exports = "<p>\r\n  bankslist works!\r\n</p>\r\n"